"use client";

import * as React from "react";

// NOTE: The "cyber" style is parked for now. Claude is the active style.
// To bring the toggle back: restore the localStorage logic below, the
// commented option in `style-toggle.tsx`, and the <StyleToggle /> in the navbar.
export type SiteStyle = "cyber" | "claude";

type StyleContextValue = {
  style: SiteStyle;
  setStyle: (style: SiteStyle) => void;
};

const StyleContext = React.createContext<StyleContextValue | undefined>(
  undefined
);

// const STORAGE_KEY = "gerawrdog-style";

const ACTIVE_STYLE: SiteStyle = "claude";

export function StyleProvider({ children }: { children: React.ReactNode }) {
  const [style, setStyleState] = React.useState<SiteStyle>(ACTIVE_STYLE);

  React.useEffect(() => {
    document.documentElement.setAttribute("data-style", style);
  }, [style]);

  /* --- Cyber toggle (parked) ---------------------------------------------
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as SiteStyle | null;
    if (stored === "cyber" || stored === "claude") {
      setStyleState(stored);
    }
    setMounted(true);
  }, []);

  React.useEffect(() => {
    if (!mounted) return;
    document.documentElement.setAttribute("data-style", style);
    localStorage.setItem(STORAGE_KEY, style);
  }, [style, mounted]);
  ------------------------------------------------------------------------ */

  const setStyle = React.useCallback((next: SiteStyle) => {
    setStyleState(next);
  }, []);

  return (
    <StyleContext.Provider value={{ style, setStyle }}>
      {children}
    </StyleContext.Provider>
  );
}

export function useSiteStyle() {
  const context = React.useContext(StyleContext);
  if (!context) {
    throw new Error("useSiteStyle must be used within StyleProvider");
  }
  return context;
}
